import { EmployeeDetail } from '@/modules/employees/models/EmployeeDetail'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
import TranslateUserStatus from '../translateUserStatus'
import roleNames from '../rolesName'
import { formatDate } from '@/shared/utils/formatDate'

export default function EmployeesReportXlsx(employees: EmployeeDetail[]) {
  if (!employees) {
    console.error('No filtered employees available')
    return
  }

  const transformedData = employees.map((employee: EmployeeDetail) => {
    return {
      'Código Nómina': employee.payroll.code,
      'Código empleado': employee.code,
      'Numero identificación': employee.identificationNumber,
      Nombre: employee.name,
      Nacionalidad: employee.nationality,
      Correo: employee.email,
      Cargo: employee.position,
      Salario: employee.salaryAmount,
      Moneda: employee.currency,
      'Base salarial': employee.salaryBase,
      'Saldo de vacaciones': employee.vacationBalance,
      Estado: employee.isInactive ? 'Inactivo' : 'Activo',
      'Fecha de alta': formatDate(employee.joiningDate.toString()),
      'Fecha de baja': employee.leaveDate
        ? formatDate(employee.leaveDate.toString())
        : '',
      'Email de usuario': employee.userData?.email,
      'Rol de usuario': roleNames.get(employee.userData?.roleName || ''),
      'Estado de usuario': TranslateUserStatus(
        employee.userData?.userState || ''
      ),
      Supervisor: employee.supervisor?.fullname,
      'Correo supervisor': employee.supervisor?.userData?.email,
      'Estado supervisor': TranslateUserStatus(
        employee.supervisor?.userData?.userState || ''
      ),
    }
  })

  const worksheet = XLSX.utils.json_to_sheet(transformedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Empleados')
  XLSX.writeFile(
    workbook,
    'Empleados-' + dayjs().format('DD-MM-YYYY') + '.xlsx'
  )
}
